import React, { useState } from 'react';
import appState from '../../state/AppStateContainer';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import { SettingsIcon, SearchIcon } from '../../components/svgs';
import './styles.css';
import { Loading } from '../../components/shared';
import CheckIcon from '@material-ui/icons/Check';
import { withRouter } from 'react-router';
import Field from '../../components/shared/Field/Field';
import { useTranslation } from 'react-i18next';

const OrganizationSwitcher = ({ history }) => {
  const [showOptions, setShowOptions] = useState(false);
  const [loader, toggleLoader] = useState(false);
  const [orgSlug, setOrgSlug] = useState();
  const [search, setSearch] = useState('');
  const [t] = useTranslation('settings', { keyPrefix: 'organizationSwitcher'});

  const organizations = appState.getOrganizations()
    .sort((a,b) => a.name.localeCompare(b.name))
    .filter(org => org.name.toLowerCase().includes(search.toLowerCase()) || org.organizationNumber?.toLowerCase()?.includes(search.toLowerCase()));

  const hasMultipleOrgs = appState.getOrganizations().length > 1;

  const fetchOrganizations = async () => {
    await appState.fetchUpdatedOrganizations();
  };
  React.useEffect(() => {
    setOrgSlug(appState._getCurrentOrgUrl());
  }, []);

  React.useEffect(() => {
    function handleClickEvent(e) {
      const wrapperElement = document.getElementById('organization-switcher-ddId');
      if (wrapperElement && !wrapperElement.contains(e.target) && showOptions) {
        setShowOptions(false);
      }
    }

    document.addEventListener('click', handleClickEvent);

    const orgSlug = appState._getCurrentOrgUrl();
    if (
      orgSlug === '/superadmin' &&
      appState.isSuperAdmin() &&
      history.location.pathname.includes('/projects')
    ) {
      return history.push('/');
    }

    return () => document.removeEventListener('click', handleClickEvent);
  }, [showOptions]);

  const onToggleSwitcher = async () => {
    if (!showOptions) {
      toggleLoader(true);
      await fetchOrganizations();
      toggleLoader(false);
    }
    setShowOptions(!showOptions);
    setSearch('');
  };

  const onSelectOrganization = async org => {
    const currentOrg = appState.getCurrentOrgSlug();
    if (currentOrg === org.slug) return;

    setShowOptions(false);
    let [, , endPoint] = window.location.pathname.split('/');
    const origin = window.location.origin;

    const updatedPath = `${origin}/${org.slug}/${
      currentOrg === 'superadmin' || org.slug === 'superadmin' ? 'dashboard' : endPoint
    }`;

    await appState.fetchAndSetToken(org);
    window.location = updatedPath;
  };

  const onSettings = () => {
    setShowOptions(false);
    history.push(`${orgSlug}/settings`);
  };

  return (
    <div className="organization-switcher">
      <div className="sub-organization-switcher">
        <div className="avatar-dropdown" id="organization-switcher-ddId" onClick={onToggleSwitcher}>
          <div>
            <span className="instance-name">{appState.getCurrentOrgName()}</span>
          </div>
          <div className="organization-switcher-toggle">
            {showOptions ? (
              <ExpandLessIcon fontSize="small" />
            ) : (
              <ExpandMoreIcon fontSize="small" />
            )}
          </div>
        </div>
      </div>
      <ul id="org-dropdown" className={`avatar-dropdown-options ${showOptions ? 'show' : ''}`}>
        <ul>
          {hasMultipleOrgs && (
            <li onClick={e => e.stopPropagation()}>
              <Field icon={<SearchIcon size={18} />} onChange={setSearch} value={search} ref={(ref) => {ref?.focus()}}/>
            </li>
          )}
          {loader ? (
            <Loading type="inline" />
          ) : (
            organizations.map(org => (
              <li
                key={org.slug}
                className={
                  'avatar-dropdown-option' +
                  (org.slug == appState.getCurrentOrgSlug() ? ' selected' : '')
                }
                onClick={() => onSelectOrganization(org)}
                title={org?.name?.length > 42 ? org?.name : ''}
              >
                {hasMultipleOrgs && (appState.isPurchasingActive(org)) && <span className="badge purchasing">{t('badge.purchasing', 'Inköp')}</span>}
                {hasMultipleOrgs && (appState.isSalesActive(org)) && <span className="badge sales">{t('badge.sales', 'Sälj')}</span>}
                {org.name}
                {org.slug == appState.getCurrentOrgSlug() && <CheckIcon />}
              </li>
            ))
          )}
        </ul>
        {appState.isAdminRole() && (
          <li className="avatar-dropdown-option settings" onClick={onSettings}>
            <SettingsIcon />
            {t('settingsLink', 'Inställningar')}
          </li>
        )}
      </ul>
    </div>
  );
}

export default withRouter(OrganizationSwitcher);
